import { Grid, Button, Box, Typography } from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SellerCallToAction = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        backgroundColor: "white",
        // backgroundColor: "primary.superlight",
        py: 14,
        px: 2,
        textAlign: "center",
      }}
    >
      <Typography color="primary" variant="h2" sx={{ mb: 2 }}>
        {t("landing_sell_cta_box.title")}
      </Typography>
      <Typography sx={{ maxWidth: 600, mx: "auto", mb: 4 }}>
        {t("landing_sell_cta_box.description")}
      </Typography>
      <Button
        component={Link}
        variant="contained"
        color="secondary"
        to="/registreties"
        sx={{
          // backgroundColor: "#d09e28",
          // color: "#fff",
          borderRadius: "999px",
          px: 4,
          py: 1.5,
          textTransform: "none",
          fontWeight: "bold",
        }}
      >
        {t("landing_sell_cta_box.cta")}
      </Button>
    </Box>
  );
};

export default SellerCallToAction;
